import { css } from '@emotion/core'
import * as MQ from 'styles/media-queries'

export const container = css`
  display: flex;

  align-items: center;
`

export const row = css`
  display: flex;
  ${MQ.PHONES} {
    justify-content: space-between;
  }
`
